import { CircleCheck, XCircle } from 'lucide-react';
import { ValidationState } from '../types/kycFormTabs.types';

/**
 * Get validation icon component for a given validation state.
 * Returns appropriate icon based on form validation status.
 */
export function getValidationIcon(validationState: ValidationState) {
  switch (validationState) {
    case 'valid':
      return <CircleCheck className='h-4 w-4 text-green-600' />;
    case 'invalid':
      return <XCircle className='h-4 w-4 text-red-600' />;
    default:
      return null;
  }
}
